import * as React from 'react';
import {FunctionComponent} from 'react';
import {Heading, List, ListItem} from 'spectacle';
import {Slide} from '../components/slide';
import {Sprint} from '../model/sprint';

interface OwnProps {
    sprints: Sprint[];
}

export const IdeaWeekThisWeek: FunctionComponent<OwnProps> = ({sprints}) => {
    return (
        <Slide major>
            <Heading size={1} textAlign="left" textColor="secondary">
                People this week with an Idea week
            </Heading>
            <List margin="30px 0 0" textFont="secondary" textColor="secondary" bold>
                {sprints.map((sprint) => (
                    <ListItem key={sprint.employee.name}>
                        {sprint.employee.name}
                        {sprint.estimate.name !== 'Idea week' ? ' (' + sprint.estimate.name + ')' : null}
                    </ListItem>
                ))}
            </List>
        </Slide>
    );
};
